var $01c08487af7ecd14$exports = {};
$01c08487af7ecd14$exports = {
    "colorInputLabel": (args)=>`${args.label}, ${args.channelLabel}`,
    "colorNameAndValue": (args)=>`${args.name}: ${args.value}`,
    "colorPicker": `V\xfdb\u{11B}r barvy`,
    "colorSwatch": `barevn\xfd vzorek`,
    "transparent": `pr\u{16F}hledn\xfd`,
    "twoDimensionalSlider": `2D posuvn\xedk`
};


export {$01c08487af7ecd14$exports as default};
//# sourceMappingURL=cs-CZ.module.js.map
